export const SET_LANGS = 'SET_LANGS';
export const SET_TITLE = 'SET_TITLE';
export const SET_SCHEDULE = 'SET_SCHEDULE';
export const SET_COLLECTION = 'SET_COLLECTION';
export const SET_COUNTRY_CD = 'SET_COUNTRY_CD';
export const SET_IS_ACTIVE = 'SET_IS_ACTIVE';
export const SET_DISTRICT_ID = 'SET_DISTRICT_ID';
export const SET_LOCALITY_ID = 'SET_LOCALITY_ID';
export const SET_DEFAULT_LANG = 'SET_DEFAULT_LANG';
export const SET_SELECTED_LANG = 'SET_SELECTED_LANG';
export const SET_DISTRICT_LABEL = 'SET_DISTRICT_LABEL';
export const SET_REMINDER_OPTION = 'SET_REMINDER_OPTION';
export const SET_TEMPLATE_COLOUR = 'SET_TEMPLATE_COLOUR';
export const SET_SEARCH_AT_FIRST = 'SET_SEARCH_AT_FIRST';
export const SET_IS_MULTI_DISTRICT = 'SET_IS_MULTI_DISTRICT';
export const SET_WEBAPP_CONFIGURATION = 'SET_WEBAPP_CONFIGURATION';
export const SET_IS_PROMPT_MESSAGE_OPEN = 'SET_IS_PROMPT_MESSAGE_OPEN';
export const SET_SHOULD_SEE_DISTRICT_SELECTOR = 'SET_SHOULD_SEE_DISTRICT_SELECTOR';
